(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-alpaca-difference"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alpaca-difference')) {
    customElements.define('alpaca-difference', class extends HTMLElement {
      connectedCallback() {
        this.callout = this.querySelector('.alpaca-difference__callout');
        this.features = Array.from(this.querySelectorAll('details'));
        if (!this.callout || this.initialized) return;
        this.initialized = true;
        const label = this.callout.querySelector('.alpaca-difference__label');
        const connector = this.callout.querySelector('line');
        const position = (angle) => {
          const radians = angle * Math.PI / 180;
          const x = 50 + 26 * Math.cos(radians);
          const y = 50 + 26 * Math.sin(radians);
          label.style.left = x + '%';
          label.style.top = y + '%';
          connector.setAttribute('x2', x);
          connector.setAttribute('y2', y);
          this.calloutAngle = angle;
        };
        const update = (feature) => {
          label.textContent = feature.dataset.callout;
          const x = Number(feature.dataset.calloutX) - 50;
          const y = Number(feature.dataset.calloutY) - 50;
          const target = Math.atan2(y, x) * 180 / Math.PI;
          const previous = this.calloutAngle ?? target;
          // Take the shortest path around the fixed center point.
          const destination = previous + ((target - previous + 540) % 360 + 360) % 360 - 180;
          cancelAnimationFrame(this.orbitFrame);
          if (this.calloutAngle === undefined || matchMedia('(prefers-reduced-motion: reduce)').matches) {
            position(destination);
            return;
          }
          const start = performance.now();
          const animate = (now) => {
            const progress = Math.min((now - start) / 400, 1);
            const eased = progress * progress * (3 - 2 * progress);
            position(previous + (destination - previous) * eased);
            if (progress < 1) this.orbitFrame = requestAnimationFrame(animate);
          };
          this.orbitFrame = requestAnimationFrame(animate);
        };
        this.features.forEach((feature) => {
          feature.addEventListener('toggle', () => {
            if (!feature.open) return;
            this.features.forEach((other) => { if (other !== feature) other.open = false; });
            update(feature);
          });
        });
        this.addEventListener('shopify:block:select', (event) => {
          const feature = event.target.closest('details');
          if (feature && this.contains(feature)) { feature.open = true; update(feature); }
        });
        const active = this.features.find((feature) => feature.open) || this.features[0];
        if (active) update(active);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.orbitFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
